import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import {
  composeValidators,
  mustBeCurrency,
  mustBeNumber,
  required
} from 'components/helpers/validators';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';

interface ContractLineFormProps {
  onSubmit: any;
  products: Option[];
  warehouses: Option[];
}

function ContractLineForm({ onSubmit, products, warehouses }: ContractLineFormProps) {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      <EnhancedForm
        title={'Aggiungi Nuova Linea di Contratto'}
        onSubmit={onSubmit}
        formId="addProductForm"
        hideControls={false}
        autoStyleLayout={true}
        columns={4}>
        <IdentityField
          gridSpan={2}
          name="product"
          component={AutocompleteAdapter}
          options={products}
          optionLabel="description"
          label={t('global.product')}
          type="text"
          submitObject
        />
        <IdentityField
          gridSpan={2}
          name="warehouse"
          component={AutocompleteAdapter}
          options={warehouses}
          optionValue="id"
          label={t('global.warehouse')}
          type="text"
        />
        <IdentityField
          name="unit_price"
          label={t('entities.contract_line.unit_price')}
          component={TextFieldAdapter}
          type="text"
          validate={composeValidators(required, mustBeCurrency)}
        />
        <IdentityField
          name="initial_available_units"
          label={t('entities.contract_line.initial_available_units')}
          component={TextFieldAdapter}
          type="text"
          validate={composeValidators(required, mustBeNumber)}
        />
        <IdentityField
          name="initial_discounted_units"
          label={t('entities.contract_line.initial_discounted_units')}
          component={TextFieldAdapter}
          type="text"
          validate={composeValidators(required, mustBeNumber)}
        />
        <IdentityField
          name="iva"
          label={t('entities.contract_line.iva')}
          component={TextFieldAdapter}
          type="text"
        />
        <IdentityField
          gridSpan={4}
          name="order_notes"
          label={t('entities.product.order_notes')}
          component={TextFieldAdapter}
          type="text"
          multiline
          rows={2}
        />
      </EnhancedForm>
    </div>
  );
}

export default ContractLineForm;
